import { type ReactNode } from 'react'


interface IProps {
  children: ReactNode[];
  href: string;
}

export default function MarkdownLink({
  children,
  href,
}: IProps): JSX.Element | null {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-test="markdown-link"
    >
      {children[0]}
    </a>
  )
}
